import { Component, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from '@app/core';
import * as Web3 from 'web3';
import { RandomUsernameService } from 'app/core/random-username.service';
import { ModalService } from 'app/shared/modal.service';
import { TranslateService } from '@ngx-translate/core';
import { ErrorManagerService } from 'app/core/error-manager.service';
import { SeedService } from '@app/core/seed.service';
import { SocketService } from '@app/core/socket.service';
import { AlertService } from '@app/core/alert.service';
import { BalanceHistoryService } from '@app/core/account/balance-history.service';
import { GamesService } from '@app/core/games.service';
@Component({
  selector: 'app-fairness-modal',
  templateUrl: './fairness-modal.template.html',
  styleUrls: ['./fairness-modal.template.scss'],
  animations: [],
})
export class FairnessModalComponent implements OnInit, OnDestroy {
  games: string[] = [];
  selected = 'dice';

  gameId = null;

  form: FormGroup;
  toggler: boolean = false;

  web3 = new Web3();

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private auth: AuthenticationService,
    private activatedRoute: ActivatedRoute,
    private nick: RandomUsernameService,
    private translate: TranslateService,
    private modalService: ModalService,
    private errorManager: ErrorManagerService,
    protected renderer: Renderer2,
    public seed: SeedService,
    private socket: SocketService,
    private alertService: AlertService,
    private balanceHistory: BalanceHistoryService,
    private gameVariables: GamesService
  ) {}

  public ngOnInit() {
    this.games = this.gameVariables.gamesList;
    this.createForm();

    if (this.activatedRoute.snapshot.params['id']) {
      this.gameId = this.activatedRoute.snapshot.params['id'];

      this.balanceHistory.gameDetails(this.gameId).then((response: any) => {
        this.selected = response.game;
        this.form.get('clientSeed').patchValue(response.playerSeed);
        this.form.get('serverSeed').patchValue(response.serverSeed);
      });
    }
  }

  public ngOnDestroy() {}

  createForm() {
    this.form = this.formBuilder.group({
      clientSeed: [this.seed.lastSeeds.clSeed || '0x0', [Validators.required]],
      serverSeed: [this.seed.lastSeeds.srvSeed || '0x1', [Validators.required]],
      serverSeedHashed: [{ value: '', disabled: true }],
    });

    this.serverSeedHashed();
  }

  serverSeedHashed() {
    if (!this.form.get('serverSeed').value) {
      this.form.get('serverSeedHashed').setValue('');
    } else {
      this.form.get('serverSeedHashed').setValue(this.web3.sha3(this.form.get('serverSeed').value, { encoding: 'hex' }));
    }
  }

  close() {
    this.router.navigate(['v2', { outlets: { modal: null } }]);
  }

  selectorName(name: string): string {
    if (!name) {
      return '';
    }
    return name.replace('-', ' ');
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/_v2/template/modals/fairness/fairness-modal.component.ts